// @ts-nocheck
import PropTypes from "prop-types";
import React, { useRef, useState, useEffect } from "react";
import style from "./MoveProjectFooter.module.scss";
import { getImageUrl } from "../../../commons/assets_path";
import { Loader } from "../../common/Loaders/Loader";
import { NoticeMessage } from "../../templates/flowbots/Notice/NoticeMessage";
import useLanguageChange from "../../../hooks/useLanguageChange";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

export const MoveProjectFooter = (props) => {
  const { section_id, code } = props;
  const { t } = useLanguageChange(props.locale);
  const [optionArea, setOptionArea] = useState(false);
  const [id, setId] = useState();
  const [selectCount, setSelectCount] = useState("0");
  const optionWrapRef = useRef(false);
  const [isLoading, setIsLoading] = useState(false);
  const [notice, setNotice] = useState({ isShow: false, message: "", type: "" });

  const checkedCount = () => {
    const checkboxes = Array.from(document.querySelectorAll(".js-section_content_database_id:checked"));
    return checkboxes.length;
  };

  const handleSubmit = (e, id) => {
    if (!window.confirm(t("MoveProjectFooter.本当に移動しますか？"))) {
      e.preventDefault();
    } else {
      setId(id);
      setIsLoading(true);
    }
  };

  const handleDelete = async (e) => {
    const confirmMessage = t("MoveProjectFooter.delete_message", { count: selectCount });
    if (window.confirm(confirmMessage)) {
      const ids = Array.from(document.querySelectorAll(".js-section_content_database_id:checked")).map((checkbox) =>
        checkbox.getAttribute("database_id"),
      );
      const endpoint = `/${code}/sections/${section_id}/dynamic_databases/${ids[0]}/destroy_selected_dynamic_databases`;
      setIsLoading(true);
      await axios
        .delete(endpoint, {
          data: { ids: ids },
        })
        .then((response) => {
          if (response.status === 200) {
            localStorage.setItem("dynamic_databases_delete_notice", response.data.message);
            location.reload();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          if (error.response?.status === 400) {
            setNotice({
              isShow: true,
              message: error.response?.data?.message || t("MoveProjectFooter.データベースの削除に失敗しました。"),
              type: "error",
            });
          } else {
            setNotice({
              isShow: true,
              message: t("MoveProjectFooter.データベースの削除に失敗しました。"),
              type: "error",
            });
          }
        });
    }
  };

  useEffect(() => {
    document.querySelectorAll(".js-section_content_database_id").forEach((checkbox) => {
      checkbox.addEventListener("change", () => {
        setSelectCount(checkedCount());
      });
    });
    document.querySelector("#js-select_database_ids").addEventListener("change", (e) => {
      if (e.target.checked) {
        const checkboxes = document.querySelectorAll(".js-section_content_database_id");
        setSelectCount(checkboxes.length);
      }
    });
  }, []);

  useEffect(() => {
    const noticeMessage = localStorage.getItem("dynamic_databases_delete_notice");
    if (noticeMessage) {
      setNotice({ isShow: true, message: noticeMessage, type: "notice" });
      localStorage.removeItem("dynamic_databases_delete_notice");
    }
  }, []);

  useEffect(() => {
    if (!optionWrapRef?.current) return;
    const hundleClickOutside = (e) => {
      if (!optionWrapRef.current.contains(e.target)) {
        setOptionArea(false);
      }
    };
    document.addEventListener("mouseup", hundleClickOutside);
  }, [optionArea, optionWrapRef?.current]);

  return (
    <>
      <div
        className="database-footer fixed-bottom align-items-center js-section_move_dynamic_databases"
        style={{ display: "none" }}
      >
        <div id="js-selected_db_count" className="database-footer__selected-db-count">
          {t("MoveProjectFooter.selected_db_count", { count: selectCount })}
        </div>
        <div className="m-auto">
          <div className="database-input-field d-flex align-items-center">
            <div className="d-flex align-items-center">
              <div className={style.buttonArea}>
                <div style={{ position: "relative" }}>
                  <button
                    type="button"
                    className={style.normalButton}
                    onClick={() => setOptionArea(true)}
                    data-testid="test-move-project-footer-button"
                  >
                    <img src={getImageUrl("images/icons/change.svg")} width={20} height={20} />
                    {t("MoveProjectFooter.他のプロジェクトに移動")}
                  </button>
                  {optionArea && (
                    <div
                      className={style.optionArea}
                      ref={optionWrapRef}
                      data-testid="test-move-project-footer-option-area"
                    >
                      {props.name.map((element, i) => {
                        return (
                          <button
                            style={{
                              border: "none",
                            }}
                            key={i}
                            className={style.optionLabel}
                            onClick={(e) => {
                              handleSubmit(e, element[1]);
                            }}
                            value={element[1]}
                            data-testid={`test-move-project-footer-option-label-${element[0]}`}
                          >
                            <div
                              className="d-flex justify-content-center align-items-center d-block"
                              style={{
                                backgroundColor: "#f3fafa",
                                border: "solid 1px #dce7e7",
                                width: "20px",
                                height: "20px",
                                borderRadius: "4px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "11px",
                                  fontWeight: "bold",
                                  display: "inline-block",
                                  marginTop: "0.7px",
                                  color: "#32cdc8",
                                }}
                              >
                                {element[0] === t("MoveProjectFooter.マイプロジェクト") ? (
                                  <img src={getImageUrl("images/icons/my.png")} width={15} />
                                ) : (
                                  <>{element[0].slice(0, 1)}</>
                                )}
                              </div>
                            </div>
                            <div
                              style={{
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                width: "100%",
                                textOverflow: "ellipsis",
                                textAlign: "left",
                              }}
                            >
                              {element[0]}
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
                <input type="hidden" name={"section[to_section_id]"} id={"section_to_section_id"} defaultValue={id} />
                <button
                  type="button"
                  className={style.redButton}
                  onClick={handleDelete}
                  data-testid="workflow-template-delete"
                >
                  <img src={getImageUrl("images/icons/trash_red.svg")} width={20} height={20} />
                  {t("MoveProjectFooter.削除")}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="text-right js-hide_section_move_dynamic_databases_link"
          style={{ marginRight: "80px", cursor: "pointer" }}
        >
          <img src={getImageUrl("images/icons/cancel.svg")} alt={t("MoveProjectFooter.削除")} width="20" height="20" />
        </div>
      </div>

      {isLoading && (
        <div className={style.loaderWrapper}>
          <div className={style.loaderContent}>
            <Loader loaderColor="yoom-green" loaderSize={35} />
          </div>
        </div>
      )}
      <NoticeMessage notice={notice} setNotice={setNotice} />
    </>
  );
};

MoveProjectFooter.propTypes = {
  name: PropTypes.array,
  section_contentable_type: PropTypes.string,
  locale: PropTypes.string,
  section_id: PropTypes.number,
  code: PropTypes.string,
};
